import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CENTRAL_FEATURE_KEY, CentralState } from './central.reducer';

// Selector to get the central state
const getCentralState = createFeatureSelector<CentralState>(CENTRAL_FEATURE_KEY);

//
const getIsBusy = createSelector(getCentralState, (state: CentralState) => state.isBusy);

// Selector to get the task list from the central state
const getTaskList = createSelector(getCentralState, (state: CentralState) => state.taskList);

// Selector to get the task details from the central state
const getTaskDetails = createSelector(getCentralState, (state: CentralState) => state.taskDetails);

// Selector to get the cached site list from the central state
const getSiteListData = createSelector(getCentralState, (state: CentralState) => state.cachedSiteList);

// Selector to get the cached sales people list from the central state
const getSalesPersonList = createSelector(getCentralState, (state: CentralState) => state.cachedSalesPeopleList);

// Selector to get the task list data from the central state
const getTaskListData = createSelector(getCentralState, (state: CentralState) => state.taskList);

// Selector to get the task summary data from the central state
const getTaskSummaryData = createSelector(getCentralState, (state: CentralState) => state.taskSummary);

// Selector to get the active navigation index from the central state
const getActiveNavIndex = createSelector(getCentralState, (state: CentralState) => state.activeNavIndex);

// Selector to get the central task  data from the central state
const getCentralTaskData = createSelector(getCentralState, (state: CentralState) => state.taskTotalsData);

//Selector to get the help components from the central state
const getMyHelpComponents = createSelector(getCentralState, (state: CentralState) => state.myHelpComponents);

// Selector to get the open job request totals from the central state
const getOpenJobRequestTotals = createSelector(getCentralState, (state: CentralState) => state.openJobRequestTotals);

// Exporting all selectors as a single object
export const centralQuery = {
  getTaskList,
  getIsBusy,
  getTaskDetails,
  getSiteListData,
  getSalesPersonList,
  getTaskListData,
  getTaskSummaryData,
  getActiveNavIndex,
  getCentralTaskData,
  getMyHelpComponents,
  getOpenJobRequestTotals
};

